import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import UserProfile from 'frontend/components/user-profile';
import set from 'ember-set-helper/helpers/set';
import toggle from 'ilios-common/helpers/toggle';
<template>
  {{pageTitle (t "general.admin") " | " (t "general.users") " | " @model.fullName}}
  <UserProfile
    @user={{@model}}
    @canUpdate={{@controller.canUpdate}}
    @canCreate={{@controller.canCreate}}
    @showCalendar={{@controller.showCalendar}}
    @setShowCalendar={{toggle "showCalendar" @controller}}
    @isManagingBio={{@controller.isManagingBio}}
    @setIsManagingBio={{set @controller "isManagingBio"}}
    @isManagingRoles={{@controller.isManagingRoles}}
    @setIsManagingRoles={{set @controller "isManagingRoles"}}
    @isManagingCohorts={{@controller.isManagingCohorts}}
    @setIsManagingCohorts={{set @controller "isManagingCohorts"}}
    @isManagingIcs={{@controller.isManagingIcs}}
    @setIsManagingIcs={{set @controller "isManagingIcs"}}
    @isManagingSchools={{@controller.isManagingSchools}}
    @setIsManagingSchools={{set @controller "isManagingSchools"}}
    @permissionsSchool={{@controller.permissionsSchool}}
    @permissionsYear={{@controller.permissionsYear}}
    @setPermissionsSchool={{set @controller "permissionsSchool"}}
    @setPermissionsYear={{set @controller "permissionsYear"}}
  />
</template>
